import React, { useEffect, useState } from 'react';
import { NavLink as NLink } from 'react-router-dom';
import { LoginNavItemMobile } from './CustomLoginNavItem/LoginNavItem';
import {
  Collapse, Navbar, NavbarToggler,
  Nav, NavItem
} from 'reactstrap';

import api from '../Tienda/api/api';
import functions from "../Tienda/api/functions";
import ParadigmaHeaderMenu from '../ParadigmaHeaderMenu/ParadigmaHeaderMenu';
import ParadigmaHeaderMenuMobile from '../ParadigmaHeaderMenu/ParadigmaHeaderMenuMobile';

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [menues, setMenues] = useState([]);

  const toggle = () => setIsOpen(!isOpen);
  
  const [viewSubmenuMobile, setViewSubmenuMobile] = useState(false);
  const toggleSubmenuMobile = () => setViewSubmenuMobile(!viewSubmenuMobile);
  
  useEffect(() => {
    let params = {
      "sort": ["Nombre"]
    }
    functions.get(api.api.sitio.menu, null, null, params, (data) => {
      setMenues( data.data );
		});
  }, [])

  return (
    <>
      <Navbar expand="md" className="justify-content-center">
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mx-auto" navbar>
            <NavItem>
              <NLink activeClassName="active" to="/" exact={true} className="nav-link" onClick={() => setIsOpen(false)}>
                Inicio
              </NLink>
            </NavItem>
            <NavItem>
              <NLink activeClassName="active" to="/tienda/productos" className="nav-link" onClick={() => setIsOpen(false)}>
                Productos
              </NLink>
            </NavItem>

            {/* <NavItem className='d-block d-sm-none'>
              <a href="#" className="nav-link" onClick={toggleSubmenuMobile}>
                Ver todos los Productos
              </a>
            </NavItem> */}
              {/* Menu de Productos Responsive */}
              <ParadigmaHeaderMenuMobile Menues={menues} /> 
           
            <NavItem>
              <NLink activeClassName="active" to="/tienda/ofertas" className="nav-link" onClick={() => setIsOpen(false)}>
                Ofertas
              </NLink>
            </NavItem>
            {/* <NavItem>
              <NLink activeClassName="active" to="/tuprestamoya" className="nav-link" onClick={() => setIsOpen(false)}>
                Tu prestamo ya!
              </NLink>
            </NavItem> */}
            <NavItem>
              <NLink activeClassName="active" to="/contacto" className="nav-link" onClick={() => setIsOpen(false)}>
                Contacto
              </NLink>
            </NavItem>
            <hr className="d-block d-md-none" style={{ height: "2px", width: "50%", borderWidth: "0", color: "red", backgroundColor: "white" }} />
            <LoginNavItemMobile closeHeader={() => setIsOpen(false)} />
          </Nav>
        </Collapse>
      </Navbar>
      <ParadigmaHeaderMenu IsMobile={false} Menues={menues} /> 
    </>
  )
}
export default Menu;